export interface BrandPresentation {
  readonly containerClass: string;
  readonly logoPath: string;
  readonly altText: string;
}

const DEFAULT_BRAND: BrandPresentation = {
  containerClass: 'logo',
  logoPath: '',
  altText: ''
};

const BRAND_PRESENTATIONS: Readonly<Record<string, BrandPresentation>> = {
  audibel: {
    containerClass: 'logoAudibel',
    logoPath: 'assets/logos/Audibel_Brand Logo.svg',
    altText: 'Audibel'
  },
  hearcircle: {
    containerClass: 'logoHearCircle',
    logoPath: 'assets/logos/Hear_Circle_Brand Logo.svg',
    altText: 'HearCircle'
  },
  kindilink2: {
    containerClass: 'logoKIND',
    logoPath: 'assets/logos/KIND_Brand Logo.svg',
    altText: 'KIND'
  },
  kindilink3: {
    containerClass: 'logoKIND',
    logoPath: 'assets/logos/KIND_Brand Logo.svg',
    altText: 'KIND'
  },
  soundgear: {
    containerClass: 'logoSoundGear',
    logoPath: 'assets/logos/SoundGear_Brand_Logo.svg',
    altText: 'SoundGear'
  },
  phantom: {
    containerClass: 'logoSoundGear',
    logoPath: 'assets/logos/SoundGear_Brand_Logo.svg',
    altText: 'MyPhantom by SoundGear'
  },
  nuear: {
    containerClass: 'logoNuear',
    logoPath: 'assets/logos/NuEar_Brand_Logo_New.svg',
    altText: 'NuEar'
  },
  audiosync: {
    containerClass: 'logoAudiosync',
    logoPath: 'assets/logos/Audiosync_Brand Logo.svg',
    altText: 'AudioSync'
  },
  hearshare: {
    containerClass: 'logoHearShare',
    logoPath: 'assets/logos/Hear_Share Logo.svg',
    altText: 'Hear Share'
  },
  kindilinkassist: {
    containerClass: 'logoKIND',
    logoPath: 'assets/logos/KIND_Brand Logo.svg',
    altText: 'KIND'
  },
  starkey: {
    containerClass: 'logo',
    logoPath: 'assets/logos/Starkey_Brand Logo.svg',
    altText: 'Starkey'
  },
  afflelou: {
    containerClass: 'logoAfflelou',
    logoPath: 'assets/logos/Afflelou_Acousticien_Brand Logo.svg',
    altText: 'Afflelou Acousticien'
  },
  ouiezen: {
    containerClass: 'logoOuiezen',
    logoPath: 'assets/logos/Ouizen_Brand Logo.svg',
    altText: 'OuïeZen'
  },
  iproai: {
    containerClass: 'logoIProAI',
    logoPath: 'assets/logos/iProAI Logo.svg',
    altText: 'iProAI'
  },
  proakustik: {
    containerClass: 'logoIProAI',
    logoPath: 'assets/logos/iProAI Logo.svg',
    altText: 'proAkustik'
  },
  thrive: {
    containerClass: 'logoThrive',
    logoPath: 'assets/logos/Thrive Logo.svg',
    altText: 'Thrive Hearing Control'
  }
};

export function getBrandPresentation(brand: string): BrandPresentation {
  return BRAND_PRESENTATIONS[brand.toLowerCase()] ?? DEFAULT_BRAND;
}
